import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  content: {
    padding: 25,
    marginTop: -10,
    marginBottom: 40,
    flex: 1
  },
  scrollView: {
    elevation: 3,
    marginTop: 0,
  },
  title: {
    marginTop: 20,
    marginBottom: 20,
    color: "#2C2C2E",
    fontSize: 16,
    fontFamily: 'Roboto_700Bold'
  },
  cardHighlight: {
    aspectRatio: 3.2407,
    resizeMode: "contain",
    backgroundColor: "#fff",
    marginTop: 10,
    borderTopLeftRadius: 30,
    borderBottomRightRadius: 30,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 5
  },
  circleBlue: {
    backgroundColor: "#32BFB1",
    width: 120,
    height: "100%",
    position: "absolute",
    right: 0,
    borderBottomRightRadius: 30,
    borderTopLeftRadius: 150,
  },
  contentInfoCardHighlight: {
    padding: 23,
    width: "58%",
  },
  textInfoCardHighlight: {
    fontWeight: "400",
    fontSize: 12,
    color: "#2C2C2E",
  },
  textMore: {
    fontWeight: "bold",
    color: "#2C2C2E",
    marginTop: 11,
  },
  arrowIcon: {
    backgroundColor: "#000",
    width: 17,
    height: 17,
    borderRadius: 20,
    marginTop: 11,
    marginLeft: 10,
  },
  contentMore: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  contentInvestorProfile: {
    paddingVertical: 10,
    backgroundColor: '#32BFB1',
    marginVertical: 10,
    borderRadius: 10
  },
  textInvestorProfile: {
    fontWeight: 'bold',
    color: '#fff',
    textAlign: 'center'
  }
});

export default styles;
